import axios from 'axios';
import { merge } from 'lodash';
import { routes } from '../../config';

// TODO: Improve translations by using session storage

export default {
  init(language, companyUuid, domains) {
    const transliteration = language.toLowerCase().search(/latn|cyrl/) > -1;
    const lang = transliteration ? language : `${language}-Latn`;

    return axios.all(
      domains.map(domain => axios.get(
        `${routes.tcApi}/domains/${domain}/languages/${lang}/clients/${companyUuid}`,
      )),
    ).then((responses) => {
      let obj = {};

      function mergeData(data) {
        obj = merge({}, obj, data);
      }

      responses.map(response => mergeData(response.data));

      return obj;
    });
  },
};
